import React, { Component } from 'react';
import Particle from './Particle';

export default class Contenido extends Component {
  render() {
    return (
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <Particle />

        <div className="animated-lines-bg d-flex flex-column align-items-center justify-content-center text-center py-5 animate__animated animate__zoomIn animate__slow" style={{ position: 'relative', zIndex: 1 }}>
          <img className="logoist mb-3" src="/logov.png" alt="Logo ISTMAS" />
          <h5 className="frase-institucional animate__animated animate__fadeInUp animate__delay-2s">
            Juntos somos MAS
          </h5>
        </div>
      </div>
    );
  }
}
